import React from "react";
import HomeWhoAreWe from "../components/HomeWhoAreWe";

const About = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
      <HomeWhoAreWe />
    </section>
  );
};

export default About;
